import { Link, Outlet } from "react-router-dom";
import { DiamondMark } from "../../components/ui";

/**
 * Shell for /login, /signup, /verify, and /forgot-password. Deliberately without
 * the app nav — these pages have one job — and set on the infield: chalk foul
 * lines, base paths, and the outfield arc drawn from home plate at the bottom.
 */
export function AuthLayout() {
  return (
    <div className="relative flex min-h-dvh flex-col overflow-hidden bg-navy-950 px-4 py-10 text-white sm:py-14">
      <Infield />

      <div className="relative mx-auto flex w-full max-w-md flex-1 flex-col justify-center gap-8">
        <Link
          to="/"
          className="group mx-auto flex items-center gap-2.5 font-display text-lg font-bold tracking-tight"
        >
          <DiamondMark className="h-8 w-8 transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105" />
          <span>
            Alpha <span className="text-brand-400">Tournaments</span>
          </span>
        </Link>

        <Outlet />

        <p className="text-center text-xs text-slate-400">
          <Link to="/tournaments" className="transition-colors hover:text-white">
            Browse tournaments without an account
          </Link>
        </p>
      </div>
    </div>
  );
}

/**
 * The field, seen from behind home plate: foul lines, base paths, the mound, and
 * the outfield arc. Anchored to the bottom and fitted rather than cropped, so it
 * still reads as a ballfield on a wide screen instead of a pair of crossing lines.
 */
function Infield() {
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-0 top-16 sm:top-24">
      <svg
        viewBox="0 0 1200 820"
        preserveAspectRatio="xMidYMax meet"
        aria-hidden
        className="h-full w-full text-brand-400/25"
      >
        <g fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round">
          <path d="M600 760 1160 200" />
          <path d="M600 760 40 200" />
          <path d="M600 760 800 560 600 360 400 560Z" />
          <path d="M180 340a595 595 0 0 1 840 0" />
          <circle cx="600" cy="560" r="24" />
          <path d="M582 760h36v22l-18 16-18-16Z" />
        </g>
      </svg>
    </div>
  );
}
